<form [formGroup]="basicForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue titles-left margin">{{title}}</h1>
    <p class="lead titles-left rocal">{{subtitle}}</p>

    <div class="flex blue-box">
      <p class="blue lead" >
        {{'Contact Person Information'}}
      </p>
      <div class="line-2"></div>
      <div class="row-alt">
        <div class="row-mini">
          <app-input [formGroup]="basicForm" controlName="Title"
            label={{titleLabel}} hint={{titleHint}}
            inputType="auto-complete"
            [loadingOptions]="loadingTitles"
            [ArrayItems]="TitleOptions"
            required="false"
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>

          <app-input [formGroup]="basicForm" controlName="firstName"
            label={{fNameLabel}} hint={{fNameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
          
        <div class="row-mini">
          <app-input [formGroup]="basicForm" controlName="middleName"
            label={{mNameLabel}} hint={{mNameHint}} required='false'
            [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
          <app-input [formGroup]="basicForm" controlName="surname"
            label={{surnameLabel}} hint={{surnameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
        </div>
      </div>
      <div class="row">
        <app-input [formGroup]="basicForm" controlName="email"
            label={{emailLabel}} hint={{emailHint}} type="email"
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="basicForm" controlName="idNo"
            label={{idLabel}} hint={{idHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input> 
      </div>
      <div class="row" [ngClass]="{half: region === 0}">
        <app-input [formGroup]="basicForm" controlName="phone"
          label={{phoneLabel}} inputType="phone"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="basicForm" controlName="secondaryPhone" *ngIf="region === 1"
          label={{secondaryPhoneLabel}} inputType="phone" required="false"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>    
      </div>
    </div>

    <div style="display: flex; width: 100%; align-items: center; justify-content: center;">
      <div class="flex column disclaimer" style="height: fit-content; padding-top: 16px; padding-bottom: 16px;">
        {{disclaimer}}
        <span style="color: rgb(160, 9, 9); margin-top: 8px; font-size: small;">
          Also note that the process might take approximately <strong style="font-weight: 900;">20 minutes</strong> to complete
        </span>
      </div>
    </div>
  </div>
  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;"
    [text]="
      loading ? loadingText :
      !(basicVerified && confirmValidationStatus()) ? 'Verify via OTP' :
      !consentProvided ? 'Terms and Data Privacy' : 'Next'
    "
    [formValid]="basicForm.valid"
    showContinue="false"
    [buttonClickHandler]="
      !(basicVerified && confirmValidationStatus()) ? openOtpModal.bind(this) :
      !consentProvided ? openConsentForm.bind(this) :
      submitForm.bind(this)
    ">
  </app-form-bottom>
</form>
